import React from "react";
import { Progress, Card, Badge } from "antd";

const formatDate = (dateString) => {
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      throw new Error("Invalid date");
    }
    return date.toISOString().split("T")[0];
  } catch (error) {
    console.error("Error formatting date:", error);
    return "Invalid date";
  }
};

const DepositCard = ({ policy, onClick }) => {
  return (
    <div className="pr-4">
      <Card
        className="relative w-[280px] h-[160px] bg-gradient-to-r from-white to-[#FFF8F3] rounded-lg cursor-pointer mb-2"
        onClick={onClick}
      >
        <div>
          <img
            src="/account.svg"
            alt="Vector3"
            className="absolute top-[4.5px] left-0 w-[429.5px] h-[134px] opacity-65"
          />

          <div className="flex items-center w-full mb-1">
            <h5 className="text-base font-bold text-[#221F1F] font-open-sans overflow-hidden whitespace-nowrap text-ellipsis">
              {policy.accountType}
            </h5>
          </div>

          <div className="pb-4 mb-3">
            <p className="text-sm font-normal text-[#221F1F] font-open-sans leading-[16px]">
              {parseFloat(
                policy.category == "loan"
                  ? policy.loanAmount
                  : policy.accountBalance
              ).toLocaleString("en-NG", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}{" "}
              {policy.currency}
            </p>
            <p>{policy.accountHolder}</p>
          </div>
        </div>

        <div className="flex items-center w-full gap-2 mt-3 mb-1">
          <p className="text-[#221F1F] font-semibold text-sm font-open-sans overflow-hidden whitespace-nowrap text-ellipsis">
            {/* <span><Clipboard /> </span> */}
            {policy.accountNumber}
          </p>
          <Badge
            text={policy.accountStatus}
            status={policy.accountStatus === "Active" ? "success" : "error"}
          />
        </div>
      </Card>
    </div>
  );
};

export default DepositCard;
